<template>
	<!-- 基础薪资历史记录 -->
	<lcsj-dialog v-model="dialogVisible" :title="title" width="80%" cancel-text="关闭" confirm-text="" @cancel="dialogVisible">
		<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" v-loading="loading" :data="listData" border stripe height="500px" :highlight-selection-row="true" empty-text="暂无数据" >
			<el-table-column prop="rowNumber" label="序号" width="60" align="center"></el-table-column>
			<el-table-column prop="postName" label="岗位名称" min-width="120" align="center"></el-table-column>
			<el-table-column prop="baseSalary" label="基础薪资" width="150" align="center"></el-table-column>
			<!-- <el-table-column prop="perfectAttendance" label="全勤" width="150" align="center"></el-table-column> -->
			<el-table-column prop="postWage" label="岗位工资" width="150" align="center"></el-table-column>
			<el-table-column prop="socialSecuritySubsidy" label="社保补贴" width="150" align="center"></el-table-column>
			<el-table-column prop="seniorityPay" label="工龄补贴" width="150" align="center"></el-table-column>
			<el-table-column prop="requiredAttendance" label="应出勤天数" width="120" align="center"></el-table-column>
			<el-table-column prop="creator" label="创建人" width="120" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="170" align="center"></el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		
	</lcsj-dialog>
</template>

<script>
import { GetUserBaseSalaryHistoryPageList } from "@/api/salaryApi.js";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			dialogVisible: false, //控制编辑页面显示与隐藏
			listData: [],
			pageShow: true,
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				keyId: ""
			}
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	components: {},
	methods: {
		//显示编辑界面
		showHistoryDialog(keyId, chName) {
			this.formInline.keyId = keyId;
			this.title = "【" + chName + "】" + "的基础工资调整记录";
			this.getListData();
			this.dialogVisible = true;
		},
		// 获取基础工资调整记录列表
		getListData() {
			this.loading = true;
			GetUserBaseSalaryHistoryPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 关闭编辑、增加弹出框
		handleClose() {
			this.dialogVisible = false;
			this.listData = [];
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>
<style scoped></style>
